import { controllerFactory } from "@utils/createController";
import { useMutation } from "stimulus-use";

/**
 * Simple controller that sets `disabled` attribute on submit button
 * based on the basic validity of the form (HTML validation only).
 */
export default class extends controllerFactory<HTMLFormElement>()({
  targets: {
    button: HTMLButtonElement,
    form: HTMLFormElement,
  },
}) {
  private get form(): HTMLFormElement {
    return this.hasFormTarget ? this.formTarget : this.element;
  }

  private runCheck() {
    this.buttonTarget.disabled = !this.form.checkValidity();
  }

  connect() {
    this.form.addEventListener("input", () => this.runCheck());
    this.runCheck();

    useMutation(this, { childList: true, subtree: true });
  }

  mutate() {
    this.runCheck();
  }
}
